



export class ResetPasswordRequestVM {
    
    token?: string;
    
    newPassword?: string;
    
    confirmPassword?: string;
    
}
